import { FC } from 'react';
import Paper from 'components/atoms/Paper';
import PeripheralDevices from 'components/organisms/PeripheralDevices';
import ShareSensorModal from 'components/organisms/ShareSensorModal';
import { TableSorter } from 'components/molecules/TableSorter';
import { useTabDevices } from './resources/useTabDevices';
import TableFilter from 'components/organisms/TableFilter';
import DefaultButton from 'components/atoms/Button/DefaultButton';
import { Icon } from 'components/atoms/Icons';
import { CreateDeviceWithoutGatewayDrawer } from 'functionalities/deviceWithoutGateway/createDevice/components/CreateDeviceWithoutGatewayDrawer';
import { UpdateDeviceWithoutGatewayDrawer } from 'functionalities/deviceWithoutGateway/updateDevice/components/UpdateDeviceWithoutGatewayDrawer';
import DeleteDeviceWithoutGatewayModal from 'functionalities/deviceWithoutGateway/deleteDevice/components/DeleteDeviceWithoutGatewayModal';
import AddMaintenanceActionDrawer from 'components/organisms/AddMaintenanceActionDrawer';
import { AlertNotificationDrawer } from 'functionalities/deviceAlertNotifications/components/AlertNotificationDrawer';
import AlertNotificationDeleteModal from 'functionalities/deviceAlertNotifications/components/AlertNotificationDeleteModal';
import './styles.scss';


const TabDevices: FC = () => {
  const {
    devices,
    currentPage,
    currentSize,
    totalPages,
    peripheralsTitle,
    columns,
    expandedColumns,
    shareSensorOptions,
    sorterOptions,
    initialFilters,
    gatewayId,
    createDeviceOptions,
    updateDeviceOptions,
    deleteDeviceOptions,
    maintenanceActionsDrawerOptions,
    alertNotificationOptions,
    onApplyFilters,
    onChangePage,
    onExpandDevice,
    loading,
  } = useTabDevices();

  const {
    literals: createLiterals,
    onOpenCreateDeviceDrawer,
    onCloseCreateDeviceDrawer,
    createDeviceDrawerVisible,
  } = createDeviceOptions;

  const {
    literals: updateLiterals,
    onCloseUpdateDeviceDrawer,
    updateDeviceDrawerVisible,
  } = updateDeviceOptions;

  const {
    deleteDeviceModalTranslations,
    deleteDeviceModalVisible,
    onCloseDeleteDeviceModal,
    onDeleteDevice,
    deleting,
  } = deleteDeviceOptions;

  const {
    title,
    text,
    mainButtonText,
    secondaryButtonText,
  } = deleteDeviceModalTranslations;

  const {
    maintenanceDevice,
    isMaintenanceActionsDrawerVisible,
    onCloseMaintenanceActionsDrawer,
  } = maintenanceActionsDrawerOptions;

  const {
    isAlertNotificationDrawerVisible,
    onCloseAlertNotificationDrawer,
    alertNotificationLiterals,
  } = alertNotificationOptions;


  return (
    <>
      <Paper>
        <h2>{peripheralsTitle}</h2>
        <div className={'TabDevices__buttons'}>
          <TableFilter
            loading={loading}
            initialFilters={initialFilters}
            onApply={onApplyFilters}
            isMultiple
          />
          <TableSorter
            label={sorterOptions.label}
            valueOptions={sorterOptions.valueOptions}
            value={sorterOptions.value}
            onChange={sorterOptions.onChangeSorter}
            disabled={sorterOptions.disabled}
            loading={sorterOptions.loading}
          />
          <DefaultButton
            onClick={onOpenCreateDeviceDrawer}
            icon={<Icon.Plus />}
            title={createLiterals.deviceActionButtonText}
          />
        </div>
        <PeripheralDevices
          devices={devices}
          columns={columns}
          expandedColumns={expandedColumns}
          currentPage={currentPage}
          currentSize={currentSize}
          totalPages={totalPages}
          onPagination={onChangePage}
          onExpand={onExpandDevice}
          loading={loading}
        />
      </Paper>
      <ShareSensorModal
        modalOptions={shareSensorOptions}
        open={shareSensorOptions.shareSensorModalVisible}
        onCancel={shareSensorOptions.onCloseShareSensorModal}
      />
      <CreateDeviceWithoutGatewayDrawer
        title={createLiterals.title}
        options={createDeviceOptions}
        onClose={onCloseCreateDeviceDrawer}
        open={createDeviceDrawerVisible}
      />
      <UpdateDeviceWithoutGatewayDrawer
        options={updateDeviceOptions}
        title={updateLiterals.title}
        open={updateDeviceDrawerVisible}
        onClose={onCloseUpdateDeviceDrawer}
      />
      <DeleteDeviceWithoutGatewayModal
        deleting={deleting}
        mainButtonText={mainButtonText}
        secondaryButtonText={secondaryButtonText}
        text={text}
        onCancel={onCloseDeleteDeviceModal}
        onOk={onDeleteDevice}
        title={title}
        open={deleteDeviceModalVisible}
      />
      {gatewayId && (
        <AddMaintenanceActionDrawer
          visible={isMaintenanceActionsDrawerVisible}
          gatewayId={gatewayId}
          onClose={onCloseMaintenanceActionsDrawer}
          deviceData={maintenanceDevice}
        />
      )}
      <AlertNotificationDrawer
        title={alertNotificationLiterals.title}
        options={alertNotificationOptions}
        open={isAlertNotificationDrawerVisible}
        onClose={onCloseAlertNotificationDrawer}
      />
      <AlertNotificationDeleteModal
        title={alertNotificationOptions.deleteAlertNotificationsModalLiterals.title}
        text={alertNotificationOptions.deleteAlertNotificationsModalLiterals.description}
        mainButtonText={alertNotificationOptions.deleteAlertNotificationsModalLiterals.mainButtonText}
        secondaryButtonText={alertNotificationOptions.deleteAlertNotificationsModalLiterals.secondaryButtonText}
        loading={false}
        open={alertNotificationOptions.isDeleteAlertNotificationModalVisible}
        onCancel={alertNotificationOptions.onCloseDeleteAlertNotification}
        onClick={alertNotificationOptions.onConfirmDeleteAlertNotification}
      />
    </>
  );
};

export default TabDevices;
